import {
  SizeTypeLabel,
  RoofTypeLabel,
  CabinTypeLabel,
  EngineTypeLabel,
  DrivetrainLabel,
} from '@/types';

function mapLabelToTranslation<T>(label: string, labelEnum: T) {
  return labelEnum[label as keyof T];
}

function mapSizeTypeLabelToTranslation(sizeType: string) {
  return mapLabelToTranslation(sizeType, SizeTypeLabel);
}

function mapRoofTypeLabelToTranslation(roofHeightType: string) {
  return mapLabelToTranslation(roofHeightType, RoofTypeLabel);
}

function mapCabinTypeLabelToTranslation(cabinType: string) {
  return mapLabelToTranslation(cabinType, CabinTypeLabel);
}

function mapEngineTypeLabelToTranslation(engineType: string) {
  return mapLabelToTranslation(engineType, EngineTypeLabel);
}

function mapDrivetrainTypeLabelToTranslation(drivetrain: string) {
  return mapLabelToTranslation(drivetrain, DrivetrainLabel);
}

export {
  mapSizeTypeLabelToTranslation,
  mapRoofTypeLabelToTranslation,
  mapCabinTypeLabelToTranslation,
  mapDrivetrainTypeLabelToTranslation,
  mapEngineTypeLabelToTranslation,
};
